export default __webpack_public_path__ + "static/home-630718eeb96c6708c1f80af1287b4100.mp4";